import React from 'react';

const STEPS = [
  { icon: 'fa-hand-pointer', text: 'Escolha o kit' },
  { icon: 'fa-credit-card', text: 'Selecione a forma de pagamento' },
  { icon: 'fa-house', text: 'Receba em casa' },
  { icon: 'fa-lock', text: 'Plataforma segura e seus dados não serão compartilhados' }
];

const HowToBuySection = () => {
  return (
    <section id="como-comprar" className="mgs-buy">
      <div className="mgs-buy__inner">
        <h2 className="mgs-buy__title">
          Não está acostumada a{' '}
          <span className="mgs-buy__title-gold">comprar pela internet?</span>
        </h2>

        <div className="mgs-buy__steps">
          {STEPS.map((step, i) => (
            <React.Fragment key={i}>
              <div className="mgs-buy__step">
                <div className="mgs-buy__icon">
                  <i className={`fas ${step.icon}`}></i>
                  <span className="mgs-buy__num">{i + 1}</span>
                </div>
                <p className="mgs-buy__text">{step.text}</p>
              </div>

              {i < STEPS.length - 1 && (
                <div className="mgs-buy__arrow" aria-hidden="true">
                  <i className="fas fa-chevron-right"></i>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowToBuySection;
